<template>
  <!-- 选择参会人 -->
  <div v-if="frequentUsers.length || rootCellInfo"
       class="list-layout-box" :class="[{'permit-nav':mobNavShow}]">
    <div class="top-fix-container">
      <back-route-hdr v-bind="backRouteInfo"
                      @handle-back="handleRouteBack"></back-route-hdr>
      <van-search v-model="searchText" placeholder="搜索联系人"
                  @focus="focusSearch" @search="onSearchUser" show-action>
        <template #action>
          <div @click="onSearchUser">搜索</div>
        </template>
      </van-search>
      <van-tabs v-show="!showFilter" class="bord-top" v-model="activeTab">
        <van-tab v-for="name in Object.keys(tabMap)" :key="name"
                 :title="tabMap[name]" :name="name">
        </van-tab>
      </van-tabs>
    </div>

    <div v-if="showFilter" class="ctn-mar-sm">
      <user-check-cell v-if="filterData.length" v-bind="filterUserInfo"
                       :show-dept="true"
                       @pre-dept="searchText = ''"
                       @change-users="changeUsers($event, 'filter')"></user-check-cell>
      <div v-else>
        <empty-notice :image="'search'" :desc="'暂无相关人员'"></empty-notice>
      </div>
    </div>
    <div v-else class="ctn-mar-md">
      <div v-show="activeTab === tabKeyMap.frequentUser">
        <user-check-cell v-bind="frequentUserInfo"
                         @change-users="changeUsers($event, 'frequent')"
                         @pre-dept="handlePreDept"></user-check-cell>
      </div>
      <div v-if="activeTab === tabKeyMap.personalGroup">
        <choose-groups class="mar-operate-btm"
                       v-bind="psGroupUserInfo"
                       @change-group-users="setGroupUsers"
                       @remove-user="removeUser"
                       @change-users="changeUsers($event, 'psGroup')"></choose-groups>
      </div>
      <div v-show="activeTab === tabKeyMap.structure">
        <transition name="van-fade">
          <user-check-cell v-show="showRoot && rootCellInfo"
                           v-bind="bindSubComponent('', true)"
                           @toggle-dept="handleDeptCheck"
                           @change-users="changeUsers($event, 'root')"
                           @pre-dept="submitInfo(false)"
                           @next-dept="handleNextDept"></user-check-cell>
        </transition>
        <transition name="van-slide-right">
          <user-check-cell v-show="deptIdRoutes.length"
                           v-bind="bindSubComponent(nextDeptId)"
                           @toggle-dept="handleDeptCheck"
                           @change-users="changeUsers($event, 'sub')"
                           @pre-dept="handlePreDept"
                           @next-dept="handleNextDept"></user-check-cell>
        </transition>
      </div>
    </div>

    <!--<div v-show="!showFilter && !showFrequentUsers">
      <div v-show="showRoot && frequentUsers.length" class="mar-top">
        <van-cell title="常用联系人" class="cell-btm-none"
                  :icon="showMiniFrequentUsers ? 'arrow-down' : 'arrow'"
                  @click="showMiniFrequentUsers=!showMiniFrequentUsers"></van-cell>
        &lt;!&ndash; 常用3位联系人 &ndash;&gt;
        <div v-show="showMiniFrequentUsers">
          &lt;!&ndash; 单选 &ndash;&gt;
          <van-radio-group v-if="isSingle" v-model="singleUserId">
            <van-cell-group>
              <van-cell v-for="user in miniFrequentUserInfo.list" :key="user.userId">
                <template #title>
                  <van-radio :name="user.userId">
                    <span class="color-box mar-rgt-10"
                          :style="`background-color:rgba(${user.headerColor},0.35)`">{{user.name[0]}}</span>
                    <span class="custom-title">{{user.name}}（{{user.employeeNumber || "无"}}）</span>
                  </van-radio>
                </template>
              </van-cell>
            </van-cell-group>
          </van-radio-group>
          &lt;!&ndash; 多选 &ndash;&gt;
          <checkbox-group v-else v-bind="miniFrequentUserInfo"
                          extra-key="employeeNumber"
                          @change-ids="changeUsers($event, 'frequent')">
          </checkbox-group>
          <van-cell v-show="frequentUsers.length > 3" title="" value="更多"
                    class="cell-btm-none bord-top pad-ver-5" is-link
                    @click="showFrequentUsers = true"></van-cell>
        </div>
      </div>
    </div>-->

    <div class="fixed-btm-box bord-top">
      <div class="pull-right pad-all-10">
        <van-button type="primary" size="small" @click="submitInfo(true)">确定({{selectedUsers.length}})</van-button>
      </div>
      <div v-if="selectedUsers.length" class="user-container">
        <span v-for="ele in selectedUsers" :key="ele.userId"
              class="color-box mar-rgt-10"
              :style="`background-color:rgba(${ele.headerColor},0.35)`">{{ele.name[0]}}
          <van-icon name="clear" @click="removeUser(ele.userId)" class="text-md"></van-icon>
        </span>
      </div>
    </div>
  </div>
  <div v-else-if="!loading" class="bg-white absolute-100-percent">
    <empty-notice :image="'search'" :desc="'暂无人员信息'"></empty-notice>

    <back-route-hdr :back-mode="'func'" :hash-key="'none'"
                    @handle-back="submitInfo(false)"></back-route-hdr>
  </div>
</template>

<script>
  import {checkShowPermit, frontConfirm} from "../../../../../tools/utils";
  import {account, system, personalGroup} from "../../../../../server";
  import UserCheckCell from './UserCheckCell'
  import ChooseGroups from './ChooseGroups'
  import CheckboxGroup from "../../../components/CheckboxGroup";
  import {commonConfig} from "../../../../../config/common";

  export default {
    components: {UserCheckCell, CheckboxGroup, ChooseGroups},
    props: {
      curData: Array,
      singleDoc: Object,
      isSingle: Boolean,  // 是否单选
    },
    data() {
      return {
        activeTab: "frequentUser",

        loading: true,
        showRoot: true,
        showFilter: false,
        // showFrequentUsers: false,
        // showMiniFrequentUsers: true,
        searchText: "",
        userRecord: {},
        userInfo: [],  // 存储已查过的数据

        filterData: [],  // 当前筛选列表的数据
        frequentUsers: [],  // 最近联系人
        hasPsGroups: false,  // 会议群组

        deptInfo: {},  // 存储已查过的部门
        deptMap: {},
        fetchDeptRc: [],
        deptIdRoutes: [],
        cellInfoCache: {},
        selectedInfo: {
          groupIds: [],
          userIds: {
            root: [],
            sub: [],
            filter: [],
          },
        },
        singleUserId: "",
      }
    },
    computed: {
      tabMap() {
        const list = [["structure", "企业通讯录"]];
        if (this.hasPsGroups) {
          list.unshift(["personalGroup", "会议群组"])
        }
        if (this.frequentUsers.length) {
          list.unshift(["frequentUser", "常用联系人"])
        }
        // console.log(window._.object(list))
        this.activeTab = list[0][0];
        return window._.object(list)
      },
      tabKeyMap() {
        return window._.mapObject(this.tabMap, (val, key) => key)
      },
      mobNavShow() {
        const permissionList = this.$store.state.permissionList || [];
        return checkShowPermit(permissionList, this.permitsMap.mobNav)
      },
      backRouteInfo() {
        const props = {
          backMode: commonConfig.backModes.func,
          curHash: "root",
        };
        if (this.showFilter) {
          props.curHash = "filter";
        } else if (this.showFrequentUsers) {
          props.curHash = "frequent";
        } else if (!this.showRoot && this.nextDeptId) {
          props.curHash = this.nextDeptId;
        }
        // console.log(props);
        return props
      },
      rootCellInfo() {
        const departments = this.deptInfo['root'] || [];
        if (!departments.length) return null;
        if (departments.length > 1) {
          return {
            // title: "企业通讯录",
            groups: departments,
            // userSum: (this.$store.state.sysConfig || {}).userTotal || 0,
          }
        }
        const [dept] = departments;
        return {
          deptId: dept.id,
          title: dept.name,
          // userSum: dept.userSum,
          ancestors: dept.ancestors,
          groups: this.deptInfo[dept.id] || [],
        }
      },

      nextDeptId() {
        return this.deptIdRoutes[this.deptIdRoutes.length - 1]
      },
      selectedUserIds() {
        if (this.isSingle) {
          return this.singleUserId && [this.singleUserId] || []
        }
        return [...new Set(this.selectedInfo.userIds.root.concat(this.selectedInfo.userIds.sub))]
      },
      selectedUsers() {
        const preData = this.isSingle ? [this.singleDoc] : this.curData;
        const userList = this.userInfo.map(e => e.list).flat(1).concat(preData).concat(this.frequentUsers);
        const userIds = this.selectedUserIds;
        // console.log(userIds, userList);
        return userIds.map(id => userList.find(ele => ele && ele.userId === id))
      },

      frequentUserInfo() {
        return {
          cellInfo: {
            deptId: "frequent",
            // title: "常用联系人",
            groups: [],
            // userSum: this.frequentUsers.length
          },
          userList: this.frequentUsers,
          selectedInfo: this.selectedInfo,

          singleUserId: this.singleUserId,
          isSingle: this.isSingle,
        }
      },
      filterUserInfo() {
        return {
          cellInfo: {
            deptId: 'filter',
            title: '联系人',
            // userSum: this.filterData.length,
            groups: [],
          },
          userList: this.filterData,
          selectedInfo: this.selectedInfo,
          singleUserId: this.singleUserId,
          isSingle: this.isSingle,
        }
      },
      psGroupUserInfo() {
        return {
          singleUserId: this.singleUserId,
          selectedUserIds: this.selectedUserIds,
          selectedInfo: this.selectedInfo,
          isSingle: this.isSingle,
        }
      },
      // miniFrequentUserInfo() {
      //   return {
      //     list: this.frequentUsers.slice(0, 3).map(e => ({...e, id: e.userId})),
      //     selectedIds: window._.uniq(Object.values(this.selectedInfo.userIds).flat(1)),
      //   }
      // },
    },
    watch: {
      searchText(val) {
        if (!val) {
          this.showFilter = false
        }
      },
      /*'selectedUsers.length'(val) {
        // console.log(val);
        if (this.isSingle) return;
        const groupIds = [];
        if (val) {
          const deptCountMap = {};
          this.selectedUsers.forEach(ele => {
            const excCch = {};
            ele.deptAncestors && ele.deptAncestors.forEach(pDId => {
              if (excCch[pDId]) return;
              excCch[pDId] = true;
              const dept = this.deptMap[pDId] || {id: pDId};
              deptCountMap[dept.id] = (deptCountMap[dept.id] || 0) + 1;
              if (deptCountMap[dept.id] === dept.userSum) groupIds.push(dept.id)
            })
          });
        }
        this.selectedInfo.groupIds = groupIds;
      }*/
    },
    created() {
      UILoader.load();
      this.getFrequentUsers();
      this.checkPersonalGroups();
      if (this.isSingle) {
        this.singleUserId = this.singleDoc.userId || "";
        this.getDepartments();
      } else {
        this.initCheckedDept(() => {
          this.getDepartments();
        })
      }
    },
    methods: {
      initCheckedDept(cb = () => false) {
        // console.log(this.curData);
        const deptIds = (this.curData || []).reduce((arr, ele) => arr.concat(ele.deptAncestors || []), []);
        // 获取部门
        const _deptIds = [...(new Set(deptIds))];
        if (!_deptIds.length) {
          cb(false);
          return;
        }
        this.getDepartments({deptIds: _deptIds}, () => cb(true))
      },
      // 搜索参会人
      onSearchUser() {
        if (this.searchText) {
          this.showFilter = true;

          this.handleUserList({
            textField: this.searchText
          }, {}, {pageSize: 50, pageNum: 1})
        } else {
          this.showFilter = false
        }
      },
      // 部门数据接口
      getDepartments({pid, fetchChild, deptIds} = {}, cb = () => false) {
        const dpKey = pid || 'root';
        if (fetchChild) {
          if (this.fetchDeptRc.includes(pid)) {
            cb(true);
            return;
          }
          this.fetchDeptRc.push(pid)
        } else if (!deptIds && this.deptInfo.hasOwnProperty(dpKey)) {
          cb(true);
          return;
        }
        system.queryDepartments(this, {
          queryFilter: {
            pid,
            fetchChild,
            deptIds
          }
        }).then(({searchDepartment: data = {}}) => {
          UILoader.unload();
          this.loading = false;
          // console.log(data)
          const list = (data.list || []).filter(e => e.hasUser);
          // 根目录
          if (list.length && !pid && !deptIds) {
            if (list.length === 1) {
              const [dept] = list;
              this.handleUserList({departments: [dept.id]}, {deptId: dept.id, forRoot: true});
              this.getDepartments({pid: dept.id})
            } else if (!this.isSingle) {
              this.selectedInfo.userIds.sub = this.curData.map(e => e.userId);
            }
          }
          const parentMap = {};
          list.forEach(e => {
            if (fetchChild) {
              if (parentMap[e.pid]) {
                parentMap[e.pid].push(e)
              } else {
                parentMap[e.pid] = [e]
              }
            }
            this.deptMap = {...this.deptMap, [e.id]: e};
          });
          if (fetchChild) {
            this.deptInfo = {...parentMap, ...this.deptInfo};
          } else if (!deptIds) {
            this.deptInfo = {...this.deptInfo, [dpKey]: list};
          }
          cb(true)
        }).catch(err => {
          UILoader.unload();
          this.loading = false;
        })
      },
      formatCurData(rootUsers) {
        if (this.isSingle) return;
        // console.log(this.curData);
        const rootUIds = [], subUIds = [];
        this.curData.forEach(ele => {
          const cRUser = rootUsers.find(ru => ru.userId === ele.userId);
          const {departments = []} = cRUser || {};
          cRUser && rootUIds.push(ele.userId);
          (!cRUser || departments.length > 1) && subUIds.push(ele.userId);
        });
        this.selectedInfo.userIds.root = rootUIds;
        this.selectedInfo.userIds.sub = subUIds;
      },
      // 常用联系人
      getFrequentUsers() {
        account.frequentUser(this, {inner: true}).then(({searchFrequentUserList: data = {}}) => {
          this.frequentUsers = (data.userEdges || []).map(e => ({...e.user}))
        }).catch(err => {
        })
      },
      // 判断是否有会议群组
      checkPersonalGroups() {
        if (this.$route.name.includes("front.user.group")) return;
        personalGroup.queryList(this, {
          queryFilter: {
            pageNum: 1,
            pageSize: 1
          }
        }).then(({searchPersonalGroup: data = {}}) => {
          const {personalGroupEdges = []} = data;
          this.hasPsGroups = personalGroupEdges.length && true
        }).catch(err => {
        })
      },
      // 处理参会人数据
      handleUserList(filter = {}, info = {}, paging = {}) {
        if (info.deptId && this.userRecord[info.deptId]) return;  // 查询过的已缓存

        UILoader.load();

        // 如果是搜索就分页
        if (paging.pageSize) {
          filter.pageSize = paging.pageSize
          filter.pageNum = paging.pageNum
        }

        account.queryList(this, {queryFilter: filter}).then(({searchUserList: data = {}}) => {
          UILoader.unload();
          const list = (data.userEdges || []).map(e => ({...e.user}));
          if (info.deptId) {
            this.userRecord[info.deptId] = true;
            this.userInfo.push({deptId: info.deptId, list});
            if (info.forRoot) {
              this.formatCurData(list);
            }
          } else if (info.setGroup) {
            this.setGroupUsers(list, info.checked, 'sub')
          } else {
            this.filterData = list;
            this.selectedInfo.userIds.filter = this.selectedUserIds.filter(id => {
              return this.filterData.some(f => f.userId === id)
            });
            this.userInfo.push({deptId: "filter", list})
          }
          // console.log(this.userInfo)
        }).catch(err => {
          UILoader.unload();
          // console.log(err);
          vtToast(err.message)
        });
      },

      getDeptUsers(deptId) {
        if (!deptId) return [];
        return (this.userInfo.find(e => e.deptId === deptId) || {}).list || []
      },
      bindSubComponent(deptId, isRoot) {
        return {
          cellInfo: this.cellInfoCache[deptId] || this.rootCellInfo || {},
          userList: this.getDeptUsers(deptId || this.rootCellInfo && this.rootCellInfo.deptId),
          selectedInfo: this.selectedInfo,
          isRoot: isRoot,
          singleUserId: this.singleUserId,
          isSingle: this.isSingle,
        }
      },
      setGroupUsers(list, checked, id, forCache = false) {
        this.userInfo.push({deptId: id, list});
        if (forCache === true) return;  // 仅缓存用户信息

        list.forEach(e => {
          if (this.selectedInfo.userIds.sub.includes(e.userId)) {
            if (checked) return;
            this.removeUser(e.userId)
          } else if (checked) {
            this.selectedInfo.userIds.sub.push(e.userId);
            if (this.getDeptUsers(this.rootCellInfo && this.rootCellInfo.deptId).some(ru => ru.userId === e.userId)) {
              this.selectedInfo.userIds.root.push(e.userId)
            }
          }
        })
      },
      changeUsers(data, key) {
        // console.log(key, data);
        if (this.isSingle) {
          this.singleUserId = data;
          return
        }
        const rootUsers = this.getDeptUsers(this.rootCellInfo && this.rootCellInfo.deptId);
        data.forEach(uid => {
          if (this.selectedUserIds.includes(uid)) return;
          const cRUser = rootUsers.find(ru => ru.userId === uid);
          const {departments = []} = cRUser || {};
          cRUser && this.selectedInfo.userIds.root.push(uid);
          (!cRUser || departments.length > 1) && this.selectedInfo.userIds.sub.push(uid);
        });
        const curUserIds = key === "frequent" ? Object.values(this.selectedInfo.userIds).flat(1) : this.selectedInfo.userIds[key];
        curUserIds && curUserIds.forEach(uid => {
          if (data.includes(uid)) return;
          this.removeUser(uid)
        });
        this.selectedInfo.userIds[key] && (this.selectedInfo.userIds[key] = data);
      },
      handlePreDept(val) {
        if (val) {
          if (this.showFrequentUsers) {
            this.showFrequentUsers = false;
            return
          }
          this.deptIdRoutes.splice(-1);
          if (!this.deptIdRoutes.length) {
            this.showRoot = true
          }
        }
      },
      // 选取下一个部门
      handleNextDept(dept) {
        // console.log(dept);
        // 当dept存在时执行查询下一个部门人员、下级部门
        if (dept && dept.id) {
          this.handleUserList({departments: [dept.id]}, {deptId: dept.id});
          this.getDepartments({pid: dept.id}, () => {
            this.cellInfoCache[dept.id] = {
              deptId: dept.id,
              title: dept.name,
              // userSum: dept.userSum,
              groups: this.deptInfo[dept.id] || [],
            };
            this.deptIdRoutes.push(dept.id);
            this.showRoot = false;
          })
        }
      },
      handleDeptCheck(data) {
        const {dept, checked} = data;
        if (checked) {
          this.selectedInfo.groupIds.push(dept.id)
        } else {
          const idx = this.selectedInfo.groupIds.indexOf(dept.id);
          if (~idx) this.selectedInfo.groupIds.splice(idx, 1)
        }
        // console.log("handleDeptCheck", dept);
        this.getDepartments({pid: dept.id, fetchChild: true}, () => {
          this.handleUserList({departments: [dept.id], fetchChild: true}, {setGroup: true, checked})
        })
      },

      // 搜索栏聚集时清除内容
      focusSearch() {
        this.searchText = ""
      },
      removeUser(userId) {
        if (this.isSingle) {
          this.singleUserId = "";
          return
        }
        Object.keys(this.selectedInfo.userIds).forEach(k => {
          const idx = this.selectedInfo.userIds[k].findIndex(e => e === userId);
          if (~idx) {
            this.selectedInfo.userIds[k].splice(idx, 1);
          }
        })
      },
      submitInfo(change) {
        if (change) {
          this.$emit('change-info', this.selectedUsers)
        } else {
          if (this.isSingle) {
            if (this.singleUserId === this.singleDoc.userId) {
              this.$emit('change-info', null);
              return
            }
          } else if (this.curData.length === this.selectedUserIds.length) {
            const concatArr = [...new Set(this.curData.map(e => e.userId).concat(this.selectedUserIds))];
            // 无更改
            if (concatArr.length === this.curData.length) {
              this.$emit('change-info', null);
              return
            }
          }
          frontConfirm({msg: "是否丢弃当前更改？"}, () => {
            this.$emit('change-info', null)
          })
        }
      },
      handleRouteBack(hashKey) {
        switch (hashKey) {
          case 'filter':
            this.searchText = "";
            return;
          case 'root':
            this.submitInfo(false);
            return;
          default:
            this.handlePreDept(1);
        }
      }
    }
  }
</script>

<style scoped>
</style>
